/**
 * Replaces each tier's static spend subtitle with the real bounds from
 * LoyaltyLion, so the thresholds can't drift from the programme. Reads
 * program only (not customer), so it works for logged-out visitors too.
 * If LoyaltyLion never loads, the hardcoded subtitle is left alone.
 */
(() => {
  const TIMEOUT = 8000;

  const waitForProgram = () =>
    new Promise((resolve, reject) => {
      const started = Date.now();

      const check = () => {
        const tiers = window.loyaltylion && window.loyaltylion.program && window.loyaltylion.program.loyaltyTiers;

        if (Array.isArray(tiers) && tiers.length) {
          resolve(tiers);
          return;
        }

        if (Date.now() - started >= TIMEOUT) {
          reject(new Error('LoyaltyLion programme did not load in time'));
          return;
        }

        setTimeout(check, 150);
      };

      check();
    });

  // Bounds are in minor units. Whole pounds drop the pence: £500, not £500.00.
  const money = (minorUnits) => {
    const value = minorUnits / 100;
    const digits = Number.isInteger(value) ? 0 : 2;
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      }).format(value);
    } catch (error) {
      return `£${value.toFixed(digits)}`;
    }
  };

  const range = (tier) => {
    const lower = tier.bounds && Number(tier.bounds.lower);
    if (!Number.isFinite(lower)) return null;

    const upper = tier.bounds.upper;
    // Top tier has no upper bound. Never gate on upper being exclusive — LoyaltyLion
    // reports 49999, so it formats straight to £499.99.
    if (upper === null || upper === undefined) return `${money(lower)}+`;

    return `${money(lower)}–${money(upper)}`;
  };

  const sortedByBound = (tiers) =>
    tiers.slice().sort((a, b) => ((a.bounds && a.bounds.lower) || 0) - ((b.bounds && b.bounds.lower) || 0));

  const apply = (tiers) => {
    const ranked = sortedByBound(tiers);

    document.querySelectorAll('[data-tier-threshold]').forEach((el) => {
      const wanted = (el.dataset.tierName || '').trim().toLowerCase();
      const byName = tiers.find((tier) => String(tier.name || '').trim().toLowerCase() === wanted);
      const tier = byName || ranked[Number(el.dataset.tierIndex)];
      if (!tier) return;

      const text = range(tier);
      if (!text) return;

      const label = el.dataset.spendLabel;
      el.textContent = label ? `${text} ${label}` : text;
    });
  };

  waitForProgram()
    .then(apply)
    .catch(() => {});
})();
